import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { Quotation, NegotiatedPrice, QuotesService } from '@app/core/quotes';
import { SettingsService } from '@app/core/settings/services/settings.service';

import { QuotationPopupFormComponent } from '../quotation-popup-form/quotation-popup-form.component';

@Component({
  selector: 'cnc-negotiate-price-form',
  templateUrl: './negotiate-price-form.component.html',
  styleUrls: ['./negotiate-price-form.component.scss'],
})
export class NegotiatePriceFormComponent implements OnInit {
  submitted :boolean = false;
  loading :boolean = false;
  pageTitle :string = this.translate.instant('TITLES.NEGOTIATE_PRICE');
  formData :UntypedFormGroup;
  isChecking :boolean = true;
  negotiatedPrice :NegotiatedPrice;
  sysSettings :any = {};

  @Input() quotation :Quotation;

  constructor(
    private quoteService :QuotesService,
    public activeModal :NgbActiveModal,
    private modalSvc :NgbModal,
    public settingsSvc :SettingsService,
    private translate :TranslateService,
  ) {}

  ngOnInit() {
    this.quoteService
      .getQuotationPriceNegotiations(this.quotation.id)
      .subscribe((records :any[]) => {
        this.isChecking = false;
        this.negotiatedPrice = records[0];
        if (this.negotiatedPrice.variants) {
          this.negotiatedPrice.variants = JSON.parse(this.negotiatedPrice.variants);
        }
      });
  }

  updateQuotation() {
    this.activeModal.dismiss();
    const modalRef = this.modalSvc.open(QuotationPopupFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.quotation = this.quotation;
    modalRef.componentInstance.negotiatedPrice = this.negotiatedPrice;
  }
}
